import common from "../common";
import core from "../core";
import context_ from "../modules/context";
import utilities_ from "../modules/utilities";
import AjaxRequest_ from "./AjaxRequest";

const context = require("../modules/context") as typeof context_;
const utilities = require("../modules/utilities") as typeof utilities_;
// const AjaxRequest = require("./AjaxRequest") as AjaxRequest_;

declare function require(module: string): unknown;

//const jsUtilities = require("../../js/jsUtilities") as any;

interface IGetConfig {
    /** Default is FALSE */
    authorizeCache?: boolean;
}
class AjaxService {

    /** Post d'un formulaire (creera un FormData a l'interieur, utilise pour le support des Files). 
     * Si 'formTarget' est NULL, alors les champs du formulaire ne sera pas poste au serveur.
    */
    postForm(url: string,
        formTarget?: string | null,
        additionalArgs?: any | null,
        ensureNavigationContextExistsInUrl?: boolean,
        onSuccess?: (data: any) => void,
        onError?: (errors: common.IError[], config?: common.IHotEditableFormConfig) => void,
        onBefore?: () => void,
        onAfter?: (isSuccess: boolean) => void,
        includeDisabledInput?: boolean) {

        const formData = utilities.extractFormData(formTarget);
        if (!!formTarget && includeDisabledInput) {
            //include disabled textbox
            const $e = $(formTarget + " input[disabled]");
            for (let i = 0; i < $e.length; i++) {
                const $d = $e[i] as HTMLInputElement;
                if (($d.attributes as any)['name']) {
                    const n = ($d.attributes as any)['name'].value;
                    const v = $d.value || null;
                    //if (!fd.has(k))//HACK|IE11: voir canisee FormData (methode 'has' non-supportee)
                    formData.append(n, v as string);
                }
            }
        }

        if (additionalArgs)
            for (const k in additionalArgs)
                if (additionalArgs.hasOwnProperty(k))
                    //if (!fd.has(k))//HACK|IE11: voir canisee FormData (methode 'has' non-supportee)
                    formData.append(k, additionalArgs[k]);

        const r = this.postFormData(url, formData, ensureNavigationContextExistsInUrl, onSuccess, onError, onBefore, onAfter);

        return r;
    }

    /** Post d'un FormData (a utiliser pour poster des Files). */
    postFormData(url: string,
        formData?: FormData,
        ensureNavigationContextExistsInUrl?: boolean,
        onSuccess?: (responseData: any) => void,
        onError?: (errors: common.IError[], config?: common.IHotEditableFormConfig) => void,
        onBefore?: () => void,
        onAfter?: (isSuccess: boolean) => void) {
        ensureNavigationContextExistsInUrl = ensureNavigationContextExistsInUrl === true;

        if (!url)
            throw "L'url est requise.";

        if (ensureNavigationContextExistsInUrl && this.navigationContextNotExistsInUrl(url))
            return null;

        if (onBefore)
            onBefore();

        //https://stackoverflow.com/questions/32421527/formdata-object-not-working-with-jquery-ajax-post
        const xhr = $.ajax({
            url: url,
            type: "POST",
            processData: false,
            contentType: false,
            data: formData || {},
            success: (response?: common.IResponse) => {
                var errorMessage: string;
                if (!response) {
                    errorMessage = "L'argument 'response' est NULL.";
                    if (onError) onError(new core.Error(errorMessage).toArray());
                    //if (context.env.) jsUtilities.print(errorMessage, jsUtilities.printTypes.error);
                    return;
                }

                if (!response.info) {
                    errorMessage = "Mauvaise envelope de retour.";
                    if (onError) onError(new core.Error(errorMessage).toArray());
                    //if (context.env.isDev) jsUtilities.print(errorMessage, jsUtilities.printTypes.error);
                    return;
                }

                if (response.info.hasError) {
                    const data = response.data || {} as common.IHotEditableFormResponseData;
                    if (onError) onError(response.info.errors, data);
                    // if (context.env.isDev) {
                    //     errorMessage = '';
                    //     for (let i = 0; i < response.info.errors.length; i++) {
                    //         const error = response.info.errors[i];
                    //         if (errorMessage) errorMessage += ', ';
                    //         errorMessage += error.message;
                    //         if (error.code) errorMessage += ' (' + error.code + ')';
                    //     }

                    //     jsUtilities.print(errorMessage, jsUtilities.printTypes.error);
                    // }
                    return;
                }

                if (onSuccess) onSuccess(response.data);
                if (onAfter) onAfter(true);
            },
            error: errorHttp => {
                const errorMessage = errorHttp.toString();
                if (onError) onError(new core.Error(errorMessage).toArray());
                //if (context.env.isDev) jsUtilities.print(errorMessage, jsUtilities.printTypes.error);
                if (onAfter) onAfter(false);
            }
        });

        return new AjaxRequest_(xhr);
    }

    // /** Convertira le 'postArguments' en FormData avant de poster. */
    // postAsFormData(url: string,
    //     postArgument?: any,
    //     onSuccess?: (responseData: any) => void,
    //     onError?: (errors: common.IError[]) => void,
    //     onBefore?: () => void,
    //     onAfter?: (isSuccess: boolean) => void) {
    //     const fd = utilities.toFormData(postArgument);
    //     this.postFormData(url, fd, onSuccess, onError, onBefore, onAfter);
    //     return this;
    // }

    /** Post standard. Ne supporte pas le post de FormData ni les Files. */
    post(url?: string,
        postArgument?: any,
        ensureNavigationContextExistsInUrl?: boolean,
        onSuccess?: (responseData: any) => void,
        onError?: (errors: common.IError[], config?: common.IHotEditableFormConfig) => void,
        onBefore?: () => void,
        onAfter?: (isSuccess: boolean) => void) {
        ensureNavigationContextExistsInUrl = ensureNavigationContextExistsInUrl === true;

        if (!url)
            throw "L'url est requise.";

        if (ensureNavigationContextExistsInUrl && this.navigationContextNotExistsInUrl(url))
            return null;

        if (onBefore)
            onBefore();

        const xhr = $.post(url, postArgument || {}, (response?: common.IResponse) => {
            var errorMessage: string;
            if (!response) {
                errorMessage = "L'argument 'response' est NULL.";
                if (onError) onError(new core.Error(errorMessage).toArray());
                if (context.env.currentIsLab) utilities.printError(errorMessage);
                return;
            }

            if (!response.info) {
                errorMessage = "Mauvaise envelope de retour.";
                if (onError) onError(new core.Error(errorMessage).toArray());
                if (context.env.currentIsLab) utilities.printError(errorMessage);
                return;
            }

            if (response.info.hasError) {
                const data = response.data || {} as common.IHotEditableFormResponseData;
                if (onError) onError(response.info.errors, data);
                if (context.env.currentIsLab) {
                    errorMessage = '';
                    for (let i = 0; i < response.info.errors.length; i++) {
                        const error = response.info.errors[i];
                        if (errorMessage) errorMessage += ', ';
                        errorMessage += error.message;
                        if (error.code) errorMessage += ' (' + error.code + ')';
                    }

                    if (context.env.currentIsLab) utilities.printError(errorMessage);
                }

                return;
            }

            if (onSuccess) onSuccess(response.data);
            if (onAfter) onAfter(true);
        }).fail(errorHttp => {
            const errorMessage = context.resources.get("UneErreurEstSurvenueSiVotreConnexionEstEchueVeuillezVousReconnecterDeNouveau");
            if (onError) onError(new core.Error(errorMessage).toArray());
            if (context.env.currentIsLab) utilities.printError(errorMessage);
            if (onAfter) onAfter(false);

            utilities.printError(errorMessage);
            utilities.printError(errorHttp);
        });

        return new AjaxRequest_(xhr);
    }

    get(url: string,
        config?: IGetConfig | null,
        ensureNavigationContextExistsInUrl?: boolean,
        onSuccess?: (result: any) => void,
        onError?: (errors: common.IError[]) => void,
        onBefore?: () => void,
        onAfter?: (isSuccess: boolean) => void) {
        config = config || {} as IGetConfig;
        ensureNavigationContextExistsInUrl = ensureNavigationContextExistsInUrl === true;

        if (!url)
            throw "L'url est requise.";

        if (ensureNavigationContextExistsInUrl && this.navigationContextNotExistsInUrl(url))
            return null;

        if (onBefore)
            onBefore();

        if (config.authorizeCache !== true)
            url += (url.indexOf('?') < 0 ? "?" : "&") + "t=" + Date.now();
        const xhr = $.get(url, {}, (result: any) => {
            if (onSuccess) onSuccess(result);
            if (onAfter) onAfter(true);
        }).fail(errorHttp => {
            const errorMessage = context.resources.get("UneErreurEstSurvenueSiVotreConnexionEstEchueVeuillezVousReconnecterDeNouveau");
            if (onError) onError(new core.Error(errorMessage).toArray());
            if (context.env.currentIsLab) utilities.printError(errorMessage);
            if (onAfter) onAfter(false);

            utilities.printError(errorMessage);
            utilities.printError(errorHttp);
        });

        return new AjaxRequest_(xhr);
    }

    private navigationContextNotExistsInUrl(url: string) {
        if (utilities.navigationContextExistsInUrl(url))
            return false;
        const errorMessage = "ATTENTION! L'url '" + url + "' ne contient pas de NavigationContext.";
        if (context.env.currentIsLocal || context.env.currentIdentifier === 'Dev')
            throw errorMessage;
        console.error(errorMessage);
        return true;
    }
}

export = AjaxService;